import { Button } from "antd";
const ButtonGroup = Button.Group;
import moment from "moment";
import isFunction from "lodash/isFunction";
import ResourceDatePickerArrow from './ResourceDatePickerArrow'
import { WeaButton, /*WeaDatePicker,*/ WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
import "./index.less";

export default class ResourceDateSwitch extends React.Component {
    static defaultProps = {
        datePickerProps: {}
    };
    constructor(props) {
        super(props);
        this.state = {
            typeList: props.typeList,
            currentType: props.currentType,
            currentDay: props.currentDay,
            C_N: props.C_N || false
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.currentDay != this.props.currentDay) {
            this.setState({
                currentDay: nextProps.currentDay
            });
        }
        if (nextProps.currentType != this.props.currentType) {
            this.setState({
                currentType: nextProps.currentType
            });
        }
    }
    getCurrentButtonText = (currentType) => {
        const { weekstart } = this.props;
        let text = '';
        switch(currentType) {
            case "year":
                text = getLabel("15384", "本年");break;
            case "month":
                text = getLabel("15541", "本月");break;
            case "week":
                text = weekstart==="3"?getLabel('383202','最近7天'):getLabel("15539", "本周");break;
            default:
                text = getLabel("15537", "今天");break;
        }
        return text
    }
    render() {
        const { className = "", style, datePickerProps, ecId, weekstart } = this.props;
        let { currentDay, currentType, typeList } = this.state;
        let value = moment.isMoment(currentDay) ? currentDay.toDate() : currentDay;
        let pickerProps = {
            arrow: true,
            type: currentType,
            weekstart,
            onChange: this.onPick,
            value,
            className: "switch-picker ",
            C_N: this.state.C_N,
            datePickerProps: datePickerProps
        };
        let currentButtonText = this.getCurrentButtonText(currentType)
        return (
            <div className={`wea-date-switch ${className}`} style={style}>
                <ButtonGroup ecId={`${ecId}_ButtonGroup@97p46v`}>
                    {typeList.map(type => {
                        let label = undefined;
                        switch (type) {
                            case "day":
                                label = getLabel("390", "日");
                                break;
                            case "week":
                                label = getLabel("1926", "周");
                                break;
                            case "month":
                                label = getLabel("33452", "月");
                                break;
                            case "year":
                                label = getLabel("26577", "年");
                                break;
                            default:
                                break;
                        }
                        return (
                            <Button
                                ecId={`${ecId}_Button@97p46v@${type}`}
                                type={currentType == type ? "primary" : "ghost"}
                                onClick={() => this.setCurrentType(type)}
                            >
                                {label}
                            </Button>
                        );
                    })}
                </ButtonGroup>
                <ResourceDatePickerArrow {...pickerProps} ecId={`${ecId}_WeaDatePicker@97p46v`} />
                <WeaButton
                    ecId={`${ecId}_WeaButton@cjtyz8`}
                    type="ghost"
                    text={currentButtonText}
                    disabled={false}
                    onClick={this.setCurrentDay.bind(this, new Date())}
                />
                {this.props.children}
            </div>
        );
    }

    getCurrentType = () => {
        this.state.currentType;
    };

    setCurrentType = type => {
        this.setState(
            {
                currentType: type
            },
            this.onChange
        );
    };

    getCurrentDay = () => {
        this.state.currentDay;
    };

    setCurrentDay = day => {
        this.setState(
            {
                currentDay: day
            },
            this.onChange
        );
    };

    parseDate = (value, type = this.state.currentType) => {
        if (!value)
            return type == "day" || type == "week"
                ? getLabel("27938", "请选择日期")
                : type == "month"
                    ? getLabel("385895", "请选择月份")
                    : getLabel("385896", "请选择年份");
        let curMoment = value._isAMomentObject ? value : moment(value);
        let curMomentCopy = moment(curMoment);
        let { weekFirstDay } = this.props;
        let yearFormat = getLabel("386427", "YYYY年");
        let monthDayFormat = getLabel("386428", "MM月DD日");
        let dayFormat = getLabel("386429", "YYYY年MM月DD日");
        let monthFormat = getLabel("386679", "YYYY年MM月");
        switch (type) {
            case "year":
                return curMomentCopy.format(yearFormat);
            case "month":
                return curMomentCopy.format(monthFormat);
            case "week": {
                let curDay = curMomentCopy.day();
                curMomentCopy.day(weekFirstDay);
                let weekFirstDayNum = curMomentCopy.day();
                if (weekFirstDayNum < curDay) {
                    return (
                        curMomentCopy.format(dayFormat) +
                        "~" +
                        curMomentCopy.day(weekFirstDay + 6).format(monthDayFormat)
                    );
                } else {
                    return (
                        curMomentCopy.day(weekFirstDay - 7).format(dayFormat) +
                        "~" +
                        curMomentCopy.day(weekFirstDay + 6).format(monthDayFormat)
                    );
                }
            }
            case "day":
            default:
                return curMomentCopy.format(dayFormat);
        }
    };

    onPick = date => {
        if (!date) date = new Date();
        let dateCopy = moment(date);
        this.setState(
            {
                currentDay: dateCopy
            },
            this.onChange
        );
    };
    onChange = () => {
        if (isFunction(this.props.onChange)) {
            let { currentDay, currentType } = this.state;
            let curMomentCopy = moment(currentDay);
            curMomentCopy.fmt = () => curMomentCopy.format("YYYY-MM-DD");
            let date = [];
            switch (currentType) {
                case "year":
                    date.push(moment(curMomentCopy).dayOfYear(1));
                    date.push(moment(curMomentCopy).dayOfYear(366));
                    break;
                case "month":
                    date.push(moment(curMomentCopy).date(1));
                    date.push(moment(curMomentCopy).date(31));
                    break;
                case "week": {
                    date.push(moment(curMomentCopy).day(0));
                    date.push(moment(curMomentCopy).day(6));
                    break;
                }
                case "day":
                default:
                    date.push(curMomentCopy);
            }
            this.props.onChange(currentType, currentDay, date);
        }
    };
}

ResourceDateSwitch.defaultProps = {
    typeList: ["day", "week", "month"],
    currentType: "day",
    weekFirstDay: 0
};

ResourceDateSwitch.propTypes = {
    typeList: React.PropTypes.array, // 类型列表，要展示出来的类型的数组，支持 year,month,week,day
    currentType: React.PropTypes.string, // 当前选中类型
    weekFirstDay: React.PropTypes.any, //周的第一天，支持0~6,Sun~Sat
    currentDay: React.PropTypes.any, //当前天数，支持传入js Date, yyyy-MM-dd, 也可传入moment对象.
    onChange: React.PropTypes.func //onChange事件,参数为type,date(moment), dateRange[moment]
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/view-resource/ResourceDateSwitch/index.js